export default { 'ec-blue': '#7fa8d7', 'ec-light-blue': '#edf6fc', 'ec-dark-blue': '#28547e' };
